<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-bestContactEmailAddress">Service Item Rush</h5>
  </div>
  <form #bestContactEmailAddressForm="ngForm">
    <div class="modal-body">
      <p>
        Rushing a service item will prioritize its processing. Please provide an email address in the event Arizona
        Department of Education staff needs to contact you regarding this service item.
      </p>
      <div class="form-group">
        <label for="bestContactEmailAddressInput" class="mb-1">Best Contact Email Address</label>
        <input
          #bestContactEmailAddressInput="ngModel"
          class="form-control"
          type="text"
          id="bestContactEmailAddressInput"
          name="bestContactEmailAddress"
          [(ngModel)]="bestContactEmailAddress"
          placeholder="Enter a valid email address..."
        />
        <div validationErrors [for]="bestContactEmailAddressInput.control" [errorEmitter]="errorEmitter"></div>
      </div>
      <div formLevelValidationErrors [for]="bestContactEmailAddressForm" [errorEmitter]="errorEmitter"></div>
    </div>
    <div class="modal-footer d-flex">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button>
    </div>
  </form>
</div>
